import { render, staticRenderFns } from "./Whois.vue?vue&type=template&id=64d49177"
import script from "./Whois.vue?vue&type=script&lang=js"
export * from "./Whois.vue?vue&type=script&lang=js"
import style0 from "./Whois.vue?vue&type=style&index=0&id=64d49177&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports